<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3"  v-if="erpSettings.userBranch">
      <v-select
          v-model="branchCodeValue"
          label="Şube Kodu"
          filled
          solo

          dense
          :items="branchList"
          item-value="code"
          item-text="name"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="safeDepositValue"
          label="Kasa Kodu"
          filled
          solo
          dense
          clearable
          :items="bankSafeDepositList"
          item-text="name"
          item-value="code"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="typeValue"
          label="Tip"
          filled
          solo
          dense
          clearable
          :items="[{value: 1, text:'Banka'}, {value: 2, text:'Cari'}, {value: 3, text:'Çek'}, {value: 4, text:'Fatura'}, {value: 5, text:'Muhtelif'}, {value: 6, text:'Senet'}, {value: 7, text:'Transfer'}]"
          item-value="value"
          item-text="text"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="statusValue"
          label="Durum"
          filled
          solo
          dense
          clearable
          :items="[{value: 1, text:'Gelir'}, {value: 2, text:'Gider'}]"
          item-value="value"
          item-text="text"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          :items="companyList"
          item-text="name"
          item-value="name"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";

export default {
  name: "KasaRaporu",
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchCompanyList({
      params: {

      },
      body: {

      }
    });
    this.fetchBranchList({
      params: {

      },
      body: {

      }
    });
    this.fetchSafeDepositsList({
      params: {
        branchCode: this.user.userInfo.branchCode === -1 ? 0 : this.user.userInfo.branchCode,
      },
    });
  },
  computed:{
    ...mapState("auth",["user"]),
    ...mapState("current",["salesPersonList"]),
    ...mapState("company",["companyList"]),
    ...mapState("company",['branchList']),
    ...mapState("bank",['bankSafeDepositList']),
    ...mapState("settings", ["erpSettings"]),
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      branchCodeValue: null,
      safeDepositValue: null,
      typeValue: null,
      statusValue: null,
      reportDbName: null
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  methods:{
    ...mapActions("current", ["fetchSalesPersonList"]),
    ...mapActions("company", ["fetchCompanyList","fetchBranchList"]),
    ...mapActions("bank", ["fetchSafeDepositsList"]),
    ...mapMutations("company",['setBranchList']),
    formattedDate,
    validationMessages,
    async getBranchList(){
      await this.fetchBranchList({
        params:{},
        body:{}
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({code: 0, name: 'Tüm Şubeler'})
      this.setBranchList(tempBranchList);
    },
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          SafeCode: this.safeDepositValue,
          Status: this.statusValue,
          Type: this.typeValue,
          BranchCode: this.branchCodeValue
        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
  }
}
</script>

<style scoped>

</style>